import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { Text } from 'ui/styles/utils'
import getRelativeUrl from 'utils/getRelativeUrl'
import FadeEntry from 'ui/components/generic/FadeEntry'
import IconListen from 'ui/components/generic/IconListen'
import withConcerts from 'containers/withConcerts'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
  height: 100vh;
`

const Label = styled.div`
  position: relative;
  color: #fff;
  margin-bottom: 30px;

  &:before {
    display: block;
    content: '';
    position: absolute;
    bottom: -15px;
    left: 0px;
    right: 0px;
    height: 1px;
    background-color: #fff;
    opacity: 0.3;
  }

  a {
    color: #fff;
  }
`

const ViewMore = Label.extend`
  display: flex;
  justify-content: space-between;

  margin-top: 40px;
  text-align: right;

  &:before {
    bottom: auto;
    top: -15px;
  }

  a {
    display: inline-flex;
    align-items: center;

    svg {
      display: block;
      height: 16px;
      margin-right: 10px;
    }
  }
`

const Details = Text.extend`
  display: flex;
  align-items: center;
  line-height: 1;
  color: #fff;
  font-family: ${props => props.theme.displayFont};

  a {
    font-size: 14px;
    color: #fff;
  }

  img {
    width: 100px;
    margin-right: 20px;
  }
`

const displayTimeTo = date =>
  moment(date).isSameOrAfter(moment(), 'day')
    ? moment(date).calendar(null, {
        sameDay: '[today]',
        nextDay: '[tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[yesterday]',
        lastWeek: '[last] dddd',
        sameElse: 'DD/MM/YYYY'
      })
    : moment(date).format('DD/MM/YYYY')

class ConcertTeaser extends Component {
  render() {
    const {
      link,
      listenLink,
      presaveLink,
      label,
      title,
      releaseDate,
      image
    } = this.props

    const released = moment(releaseDate).isSameOrBefore(moment(), 'day')

    console.log(released)

    return (
      <Container fluid>
        <Wrapper>
          <Row>
            <Col sm={8} smOffset={2}>
              <FadeEntry scroll={false} delay={1000}>
                <Label>
                  {label}{' '}
                  <strong>
                    {releaseDate ? displayTimeTo(releaseDate) : ''}
                  </strong>
                </Label>
              </FadeEntry>
              <FadeEntry
                amount={20}
                direction="left"
                delay={1500}
                scroll={false}
              >
                <Details size="lg">
                  {image && <img src={image.sourceUrl} alt={title} />}
                  {title}
                </Details>
              </FadeEntry>
              <FadeEntry scroll={false} delay={2000}>
                <ViewMore>
                  {listenLink && released && (
                    <a href={listenLink}>
                      <IconListen /> Listen now
                    </a>
                  )}
                  {presaveLink && !released && (
                    <a href={presaveLink}>Presave now</a>
                  )}
                  {link && <Link to={getRelativeUrl(link)}>Read more</Link>}
                </ViewMore>
              </FadeEntry>
            </Col>
          </Row>
        </Wrapper>
      </Container>
    )
  }
}

export default withConcerts()(ConcertTeaser)



// WEBPACK FOOTER //
// ./src/ui/components/modules/ReleaseTeaser/index.js